import { ICabSchedule } from "../CabScheduling"
import { IBooking as IHotelBooking, TSelfBookedHotels } from "../HotelBookings"
import { IHotel } from "../Hotels"
import { TTravelActiviytBooking } from "../TravelActivityBookings"
import { TTripQuoteBookingsDiff } from "../TripQuoteBookingsDiff"
import { ITrip, TArrivalDepartureDetail } from "../Trips"

export type TTripOperationalBooking = Pick<
	ITrip,
	| "id"
	| "children"
	| "destinations"
	| "start_date"
	| "start_date_local"
	| "end_date"
	| "end_date_local"
	| "days"
	| "nights"
	| "trip_source"
	| "no_of_adults"
	| "contact"
	| "tourist"
	| "reference_id"
	| "operations_team"
	| "due_payments_count"
	| "cancellation_reason"
	| "arrival_details"
	| "departure_details"
	| "trip_source_contact"
	| "converted_at"
	| "converted_by"
	| "on_hold_at"
	| "on_hold_by"
	| "tenant_brand"
	| "pax_string"
> & {
	package_price: number
	cab_schedules?: Array<ICabSchedule>
	travel_activity_bookings?: Array<TTravelActiviytBooking>
	daywise_services: Array<TDaywiseOperationalBookingService>
	is_shared?: boolean
	can_modify?: boolean
	is_locked?: boolean
	can_view_prices?: boolean
	total_payments_amount: number
	total_payments_amount_currency: string
	quote_booking_diff?: TTripQuoteBookingsDiff
}

export type TDaywiseOperationalBookingService = {
	day: number
	date: string
	date_local?: string
	checkin_hotels: Array<IHotelBooking>
	checkout_hotels: Array<IHotelBooking>
	stay_hotels: Array<IHotelBooking>
	self_booked_checkin_hotels: Array<TSelfBookedHotels>
	self_booked_checkout_hotels: Array<TSelfBookedHotels>
	self_booked_stay_hotels: Array<TSelfBookedHotels>
	arrival_details: Array<TArrivalDepartureDetail>
	departure_details: Array<TArrivalDepartureDetail>
	services: Array<{
		cab_schedule?: ICabSchedule
		travel_activity_booking?: TTravelActiviytBooking
	}>
	services_needs_reordering?: boolean
	services_ordered_by_start_time?: Array<{
		start_time_local: string
		cab_schedule_id?: number
		travel_activity_booking_id?: number
	}>
}

type TCombinedBookings = Array<{
	hotel?: IHotel
	name: string
	remarks?: string
}>
export function combineBookings({
	checkin_hotels,
	stay_hotels,
	checkout_hotels,
	self_booked_checkin_hotels,
	self_booked_stay_hotels,
	self_booked_checkout_hotels,
	showSelfBooked = false,
}: {
	checkin_hotels: Array<IHotelBooking>
	stay_hotels: Array<IHotelBooking>
	checkout_hotels: Array<IHotelBooking>
	self_booked_checkin_hotels: Array<TSelfBookedHotels>
	self_booked_stay_hotels: Array<TSelfBookedHotels>
	self_booked_checkout_hotels: Array<TSelfBookedHotels>
	showSelfBooked?: boolean
}) {
	const checkinHotels: TCombinedBookings = checkin_hotels
		.map((b) => ({
			hotel: b.hotel,
			name: b.hotel.name,
		}))
		.concat(
			self_booked_checkin_hotels.map((b) => ({
				hotel: b.hotel,
				name: b.name + (showSelfBooked ? " (Self Booked)" : ""),
				remarks: b.remarks,
			}))
		)

	const stayHotels: TCombinedBookings = stay_hotels
		.map((b) => ({
			hotel: b.hotel,
			name: b.hotel.name,
		}))
		.concat(
			self_booked_stay_hotels.map((b) => ({
				hotel: b?.hotel,
				name: b.name + (showSelfBooked ? " (Self Booked)" : ""),
				remarks: b.remarks,
			}))
		)

	const checkoutHotels: TCombinedBookings = checkout_hotels
		.map((b) => ({
			hotel: b.hotel,
			name: b.hotel.name,
		}))
		.concat(
			self_booked_checkout_hotels.map((b) => ({
				hotel: b?.hotel,
				name: b.name + (showSelfBooked ? " (Self Booked)" : ""),
				remarks: b.remarks,
			}))
		)

	return {
		checkinHotels,
		stayHotels,
		checkoutHotels,
	}
}
